import React, { useState, useEffect, useRef } from "react";
import InputForm from "./input-form.jsx";

const AsyncInput = ({id, name, label, value, onChange, fetchData, classNameWrapper, inputClass = "", labelClass = "", disabled, readOnly, required = false, invalid = false, reference}) => {
    const [results, setResults] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const isSelecting = useRef(false);

    useEffect(() => {
        if (!value || value.length < 3) {
            setResults([]);
            setIsOpen(false);
            return;
        }

        if (isSelecting.current) {
            isSelecting.current = false;
            return;
        }

        const delaySearch = setTimeout(async () => {
            setIsLoading(true);
            try {
                const data = await fetchData(value);
                setResults(data);
                setIsOpen(true);
            } catch (error) {
                console.error("Erro na busca:", error);
                setResults([]);
            } finally {
                setIsLoading(false);
            }
        }, 500);

        return () => clearTimeout(delaySearch);
    }, [value, fetchData]);

    const handleSelectOption = (item) => {
        isSelecting.current = true;
        const textValue = item["label"];

        setIsOpen(false);
        if (onChange) {
            onChange({
                target: {
                    id: id,
                    name: name || id,
                    value: textValue
                }
            });
        }
    };

    const dropdownMenu = isOpen && isFocused && (
        <ul className="absolute z-[9999] w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
            {isLoading ? (
                <li className="px-3 py-2 text-gray-500 text-sm italic">Buscando...</li>
            ) : results.length > 0 ? (
                results.map((item, index) => (
                    <li
                        key={index}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            handleSelectOption(item);
                        }}
                        className="px-3 py-2 text-gray-700 hover:bg-[#deebff] hover:text-gray-700 text-sm transition-colors cursor-pointer"
                    >
                        {item["label"]}
                    </li>
                ))
            ) : (
                <li className="px-3 py-2 text-gray-500 text-sm">Nenhum resultado</li>
            )}
        </ul>
    );

    return (
        <InputForm
            id={id}
            name={name || id}
            label={label}
            value={value || ""}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            classNameWrapper={classNameWrapper}
            inputClass={inputClass}
            labelClass={labelClass}
            required={required}
            invalid={invalid}
            reference={reference}
            placeholder=" "
            autocomplete="none"

            onFocus={() => {
                setIsFocused(true);
                setIsOpen(true);
            }}
            onBlur={() => {
                setTimeout(() => {
                    setIsFocused(false);
                    setIsOpen(false);
                }, 200);
            }}

            span={dropdownMenu}
        />
    );
};

export default AsyncInput;